import styled from "styled-components";
import colors from "../../assets/styles/colors";


export const SurveyRadioButtonList = styled.ul`
  list-style-type: none;
  margin: 25px 0 0 0;
  padding: 0;
`;

export const SurveyRadioButtonItem = styled.li`
  float:left;
  margin:0 5px 0 0;
  width:100px;
  height:40px;
  position:relative;
`;

export const SurveyRadioButtonsInput = styled.input`
  
    opacity:0.001;
    z-index:100;
    background:${colors.grayLight};
    margin-left: 5px;
  
  &:checked + label:{
    background:${colors.darkblue};
    color:${colors.white}
  }
`;

export const SurveyRadioButtonsLabel = styled.label`
    padding:5px;
    margin-right: 5px;
    cursor:pointer;
    z-index:90;
    color: ${colors.textPrimary};

`;

export const SurveyRadioButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  transition: ease-in-out .2s;
  flex-wrap: wrap;
  align-items: center;
  text-align: center;
  justify-content: center;
`;
